import { ITest, RHookFormTextFieldWithLabel } from "@websential/cosmic";

import { FC } from "react";
import { Grid } from "@mui/material";

interface IT5VariablesPanel extends ITest { }

export const T5VariablesPanel: FC<IT5VariablesPanel> = ({ testId }) => {
  return (
    <Grid
      container
      columnSpacing={6}
      rowSpacing={2}
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Eligible Taxable Amount (%)"
          id="eligibleDividendTaxCreditPercentageOfTaxableAmount"
          testId={`${testId}-cnt-rate-percentage`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Eligible Gross Up Factor (%)"
          id="eligibleGrossUpFactor"
          testId={`${testId}-wsdrf-rate-percentage`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Non Eligible Taxable Amount (%)"
          id="nonEligibleDividendTaxCreditPercentageOfTaxableAmount"
          testId={`${testId}-wsdrf-rate-percentage`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Non Eligible Gross Up Factor (%)"
          id="nonEligibleGrossUpFactor"
          testId={`${testId}-wsdrf-rate-percentage`}
        />
      </Grid>
    </Grid>
  );
};
